import React, {
  useEffect,
  useState,
} from 'react';
import {
  useObserver,
} from 'mobx-react';
import {
  Button,
} from '@material-ui/core';
import {
  stores,
} from '../../mobx-store';
import {
  UserFacebookInfo,
} from '../../mobx-store/storeInterfaces/facebookInfoInterface';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import styles from './styles.module.scss';
import {
  Pagination,
} from './types';

const DEFAULT_PAGE_SIZE = 25;
const DEFAULT_PAGE_NUMBER = 1;

const FacebookInfo: React.FC = () => {
  const [pagination, setPagination] = useState<Pagination>({
    pageNumber: DEFAULT_PAGE_NUMBER,
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const [totalNumberOfPages, setTotalNumberOfPages] = useState(1);

  useEffect(() => {
    (async function () {
      await stores.facebookInfoStore.getPaginatedFacebookInfoList(pagination.pageNumber, pagination.pageSize);
      setTotalNumberOfPages(Math.ceil(
        stores.facebookInfoStore.totalNumberOfUsers / DEFAULT_PAGE_SIZE,
      ));
    }());
  }, []);

  useEffect(() => {
    stores.facebookInfoStore.getPaginatedFacebookInfoList(pagination.pageNumber, pagination.pageSize);
  }, [pagination]);

  const tableHeaders = [
    {
      title: 'User ID',
    },
    {
      title: 'Facebook email',
    },
    {
      title: 'Facebook profile',
    },
    {
      title: 'Connected On',
    },
  ];

  const getTableData = () => stores.facebookInfoStore.usersFBInfoList.map(
    (userInfo: UserFacebookInfo) => ({
      wdUserId: userInfo.user.userId,
      fbEmail: userInfo.fbEmail,
      fbProfileUrl: userInfo.fbProfileUrl,
      connectedOn: new Date(userInfo.createdAt).toLocaleDateString('en-gb', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }),
    }),
  );

  const cellTypes: TableCellTypes[] = [
    {
      cellType: 'Text',
      key: 'wdUserId',
    },
    {
      cellType: 'Text',
      key: 'fbEmail',
    },
    {
      cellType: 'Text',
      key: 'fbProfileUrl',
    },
    {
      cellType: 'Text',
      key: 'connectedOn',
    },
  ];

  const downloadSheet = async () => {
    try {
      await stores.facebookInfoStore.downloadFacebookUsersSheet();
    } catch (err) {
      console.error(err);
      SnackBarComponent.getInstance().openSnackbar(translate('errorDownloadingFile', {
      }), 5000, 'error');
    }
  };

  const leftArrowClicked = () => {
    setPagination({
      ...pagination,
      pageNumber: pagination.pageNumber - 1,
    });
  };

  const rightArrowClicked = () => {
    setPagination({
      ...pagination,
      pageNumber: pagination.pageNumber + 1,
    });
  };

  return useObserver(
    () => (
      <div>
        <div className={styles.downloadBtn}>
          <Button
            onClick={downloadSheet}
            color="primary"
            variant="contained"
          >
            {translate('fbDownloadSheet', {
            })}
          </Button>
        </div>
        <div>
          <GeneralTableComponent
            title={translate('fbTableTitle', {})}
            emptyMessage={translate('fbEmptyTableMessage', {})}
            tableHeader={tableHeaders}
            tableData={getTableData()}
            tableCellTypes={cellTypes}
            loading={stores.facebookInfoStore.loading}
            hadPagination
            paginationAction={{
              handleClickLeftArrow: leftArrowClicked,
              handleClickRightArrow: rightArrowClicked,
              pageNumber: pagination.pageNumber,
              totalNumberOfPages,
            }}
            loadingStatus={[
              stores.facebookInfoStore.getFBInfoListRequestStatus,
            ]}
          />
        </div>
      </div>
    ),
  );
};

export default FacebookInfo;
